import { useEffect, useState } from "react";

import { customDebounce } from "utils";


export default () => {
    const [resizedWidth, setWidth] = useState(() => {
        // Use clientWidth as it's more reliable with DevTools responsive mode
        const initial = document.documentElement.clientWidth || window.innerWidth;
        return initial;
    });

    useEffect(() => {
        const ua = navigator.userAgent;
        const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

        const isDesktopUA = !/Mobi|Mobile/.test(ua);
        const platform = navigator.platform || "";
        const isAndroidPlatform = /arm|android/i.test(platform);

        const mobileDesktopMode = isTouchDevice && isDesktopUA && !isAndroidPlatform;

        if (mobileDesktopMode) {
            const DESKTOP_WIDTH = 1920;
            setWidth(DESKTOP_WIDTH);
            return;
        }

        const debouncedHandleResize = customDebounce(function handleResize() {
            // Use clientWidth as it's more reliable with DevTools responsive mode
            const newWidth = document.documentElement.clientWidth || window.innerWidth;
            setWidth(newWidth);
        }, 300);

        window.addEventListener("resize", debouncedHandleResize);
        return () => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, []);

    return resizedWidth;
};